(function () {
    'use strict';

    angular.module('PWAPoCApp')
        .factory('toasterService', ['$rootScope', '$timeout', function ($rootScope, $timeout) {

            $rootScope.toasts = [];

            function show(message, type = 'success', duration = 3000) {
                const toast = { message, type };
                $rootScope.toasts.push(toast);

                $timeout(function () {
                    const index = $rootScope.toasts.indexOf(toast);
                    if (index >= 0) $rootScope.toasts.splice(index, 1);
                }, duration);
            }

            return {
                success: function (msg) { show(msg, 'success'); },
                error: function (msg) { show(msg, 'error'); },
                info: function (msg) { show(msg, 'info'); }
            };
        }]);
})();
